import React from 'react';
import { useTranslation } from 'react-i18next';
import {EMPTY_VALUES, getDateFormat} from '../../../../../../../Apis/functions';
import SummarySection from '../../../../../../../components/Summary/SummarySection';
import SummaryDetailsCard from '../../../../../../../components/Summary/SummaryDetailsCard';
import SummaryListCard from '../../../../../../../components/Summary/SummaryListCard';
import {
    PersonChipBlack,
    FolderPerson,
    DocumentLinesIcon, IconGraphDown,
} from '../../../../../../../components/buttons/IconButtons';
import {getCalculationTypeById} from "../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model";
import CustomTooltip from "../../../../../../../components/CustomTooltip";

const StepUserDeductionSummary = ({ user, deductions, excludedGlobalRules }) => {
    const { t } = useTranslation();
    const selectedUser = user[0];

    const userItems = [
        { label: t('name'), value: selectedUser?.label ?? selectedUser?.name ?? EMPTY_VALUES.DEFAULT },
        { label: t('email'), value: selectedUser?.email ?? EMPTY_VALUES.DEFAULT },
    ];

    return (
        <div className="row mt-4 gap-3">
            <SummarySection icon={PersonChipBlack} title={t('select_user')}>
                <SummaryDetailsCard items={userItems} t={t} icon={FolderPerson} />
            </SummarySection>

            <SummaryListCard
                headerIcon={DocumentLinesIcon}
                title={t('user_deductions')}
                emptyText={t('no_information')}
                avatarIcon={IconGraphDown}
                selected={deductions}
                t={t}
                getLabel={(d) => d.name || EMPTY_VALUES.DEFAULT}
                renderValue={(rule) => {
                    const calcType = getCalculationTypeById(rule?.calculationType);
                    return <>
                        <p>{`-${calcType?.prefixText}${rule?.value}`}</p>
                        <CustomTooltip
                            text={`${getDateFormat(rule?.startDate, false)}${rule?.endDate ? ` ${t('to').toLowerCase()} `+ getDateFormat(rule?.endDate, false): '' }`}
                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row `}
                            showIfTruncated={true}
                        />
                    </>
                }}
                getKey={(d, i) => d._key ?? i}
            />

            <SummaryListCard
                headerIcon={DocumentLinesIcon}
                title={t('excluded_global_deductions')}
                emptyText={t('no_information')}
                avatarIcon={IconGraphDown}
                selected={excludedGlobalRules}
                t={t}
                getLabel={(rule) => rule.name || EMPTY_VALUES.DEFAULT}
                renderValue={(rule) => {
                    const calcType = getCalculationTypeById(rule?.calculationType);
                    return `-${calcType?.prefixText}${rule?.value}`
                }}
                getKey={(rule, i) => rule.id ?? i}
            />
        </div>
    );
};

export default StepUserDeductionSummary;
